export const DISPLAY_ALERT = 'SHOW_ALERT'
export const CLEAR_ALERT = 'CLEAR_ALERT'

// FOR REGISTER/LOGIN
export const REGISTER_USER_BEGIN = 'REGISTER_USER_BEGIN'
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS'
export const REGISTER_USER_ERROR = 'REGISTER_USER_ERROR'

export const LOGIN_USER_BEGIN = 'LOGIN_USER_BEGIN'
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS'
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR'

//LOGOUT USER

export const LOGOUT_USER = 'LOGOUT_USER'

//Toggle Sidebar
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'

//Update User
export const UPDATE_USER_BEGIN = 'UPDATE_USER_BEGIN'
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS'
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR'

//HANDLE CHANGE
export const HANDLE_CHANGE = 'HANDLE_CHANGE'

//CLEAR VALUES
export const CLEAR_VALUES = 'CLEAR_VALUES'

//CREATE JOB
export const CREATE_JOB_BEGIN = 'CREATE_JOB_BEGIN'
export const CREATE_JOB_SUCCESS = 'CREATE_JOB_SUCCESS'
export const CREATE_JOB_ERROR = 'CREATE_JOB_ERROR'
//GET ALL JOBS
export const GET_JOBS_BEGIN = 'GET_JOBS_BEGIN'
export const GET_JOBS_SUCCESS = 'GET_JOBS_SUCCESS'
//SET EDIT JOB
export const SET_EDIT_JOB = 'SET_EDIT_JOB'
//DELETE JOB
export const DELETE_JOB_BEGIN = 'DELETE_JOB_BEGIN'
//Edit JOB
export const EDIT_JOB_BEGIN = 'EDIT_JOB_BEGIN'
export const EDIT_JOB_SUCCESS = 'EDIT_JOB_SUCCESS'
export const EDIT_JOB_ERROR = 'EDIT_JOB_ERROR'
//SHOW STATS
export const SHOW_STATS_BEGIN = 'SHOW_STATS_BEGIN'
export const SHOW_STATS_SUCCESS = 'SHOW_STATS_SUCCESS'
//CLEAR FILTERS
export const CLEAR_FILTERS = 'CLEAR_FILTERS'
//CHANGE PAGE
export const CHANGE_PAGE = 'CHANGE_PAGE'
